import React from 'react';
import { useStyles } from '../styles';
import { useSelector } from 'react-redux';

import { Button, ButtonTypes } from 'app/components/Material/Inputs/Button';
import personAddIcon from 'app/assets/images/icons/person-add-icon.svg';
import { Tooltip } from 'app/components/Material/Tooltip';

export const TeamHeader = (props) => {
  const classes = useStyles();

  const { handleOpenInviteModal } = props;

  const { additionalUsers, additionalUsersLimit, additionalUsersCount } =
    useSelector((state) => state.additionalUsers);

  return (
    <div className={classes.headerContent}>
      <Button
        className={classes.buttonInvite}
        onClick={handleOpenInviteModal}
        type={ButtonTypes.secondary}
      >
        <span className={classes.buttonInvite}>
          <img src={personAddIcon} alt="" />
          <span>Invite</span>
        </span>
      </Button>
      <div className={classes.headerLeft}>
        <div className={classes.headerContentLeft}>
          <span className={classes.headerText}>Total:</span>
          <span className={classes.headerNumber}>{additionalUsersLimit}</span>
          <Tooltip title="Total" showInfoIcon={true} />
        </div>
        <div className={classes.headerContentLeft}>
          <span className={classes.headerText}>Used:</span>
          <span className={classes.headerNumber}>{additionalUsersCount}</span>
          <Tooltip title="Used" showInfoIcon={true} />
        </div>
        <div className={classes.headerContentLeft}>
          <span className={classes.headerText}>Available:</span>
          <span className={classes.headerNumber}>
            {
              additionalUsers?.filter((item) => item.status !== 'pending')
                ?.length
            }
          </span>
          <Tooltip title="Available" showInfoIcon={true} />
        </div>
      </div>
    </div>
  );
};
